/**
 *  @file       StatCard.jsx
 *  @author     Kirill Kirnichansky <kirill@distributive.network>
 *
 *  @date       December 2022
 *
 *  This is a reused component for the WorkerPanel to minimize duplicate code.
 *  The component itself is a card wrapper with a title.
 */

/**
 * Renders the component.
 *
 * @param  {object}          props           Component properties.
 * @param  {string}          props.className Class name(s) to add to the card.
 * @param  {string}          props.id        The id to add to the card.
 * @param  {string}          props.title     The title of the card.
 * @param  {React.ReactNode} props.children  The content of the card.
 * @return {JSX.Element}                     The rendered component.
 */
export function StatCard({ className, id, title, children }) {
  let classes = 'stats card';
  if (className)
    classes += ` ${className}`;
  
  return (
    <div id={id ? id : ''} className={classes}>
      <div className="cardTitle">
        <h1>{title}</h1>
      </div>
      <div className="cardContent">
        {children}
      </div>
    </div>
  );
}
